<div class="tag-container">
  @for (tag of tags; track tag) {
    <app-tag-chip [tag]="tag" [removable]="false" [isCommissioner]="true"></app-tag-chip>
  }
</div>
